import { CalendarOutlined } from "@ant-design/icons";
import { DatePicker } from "antd";
import React from "react";
import useColors from "../../hooks/useColors";

const BasicDatePicker = ({
  value,
  picker,
  onChange,
  defaultValue,
  format,
  placeholder,
  showToday = false,
  showTime = false,
  showNow = false,
  containerStyle,
  ...props
}) => {
  const { colorPrimary } = useColors()

  return (
    <div style={containerStyle}>
      <DatePicker
        onChange={onChange}
        picker={picker}
        defaultValue={defaultValue}
        format={format}
        value={value}
        placeholder={placeholder}
        showToday={showToday}
        showTime={showTime}
        showNow={showNow}
        suffixIcon={<CalendarOutlined style={{ color: colorPrimary }} />}
        {...props}
      />
    </div>
  );
};

export default BasicDatePicker;
